// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const ADMIN_MENU = 'admin-menu';
